// src/Components/Forms/Financement/Salam/Paiement/Tab1.tsx
import React from 'react';
import { Grid } from '@mui/material';
import InputForm from '../../../../InputT';
import SearchModal from '../../../../SearchModal';
import Params from '../../../../../Types/ParamsPicklist';
import { MonetizationOnOutlined, SwipeUp } from '@mui/icons-material';

// Paramètres de recherche
let searchGes: Params = { CodeAgence: '', Table: 'GESTIONNAIRE', Colonne1: 'CODGES', Colonne2: 'LIBELLE', Colagence: '101', Choix: 22 };
let searchIndice: Params = { CodeAgence: '', Table: 'CLIENT', Colonne1: 'NUMCLI', Colonne2: 'NOMCLI', Colagence: '101', Choix: 22 };
let searchTypePret: Params = { CodeAgence: '', Table: 'TYPEPRET', Colonne1: 'TYPEPRET', Colonne2: 'LIBELLE', Colagence: '101', Choix: 22 };

const Tab1 = (props: { form?: any }) => {
  return (
    <div className="tabItemAuto">
      <div>
        <Grid container className="border" sx={{ width: '85%', position: 'absolute' }}>
          {/* Colonne gauche : informations générales */}
          <Grid item xs={12} md={6} lg={6} className="border-left">
            <InputForm disabled width={7} label="N° Demande" name="NumeroDemande" type="text" />
            <InputForm disabled width={7} label="N° Financement" name="NumeroFinancement" type="text" />
            <SearchModal
              disabled
              width={7}
              form={props.form}
              Titre="Recherche Indice client"
              label="Indice client"
              name="NUMCLI"
              Parametre={searchIndice}
            />
            <SearchModal
              disabled
              width={7}
              form={props.form}
              Titre="Recherche Type Salam"
              label="Type Salam"
              name="CodeSalam"
              Parametre={searchTypePret}
            />
            {/* ✅ Gestionnaire avec SearchModal (le libellé est chargé par le parent) */}
            <SearchModal
              disabled
              width={7}
              form={props.form}
              Titre="Recherche Gestionnaire"
              label="Gestionnaire"
              name="CODGEA"
              Parametre={searchGes}
            />
            <InputForm
              disabled
              width={7}
              label="Date Demande"
              icon={<SwipeUp color="disabled" fontSize="small" />}
              name="DateDemande"
              type="date"
            />
            <InputForm
              disabled
              width={7}
              label="Date Validation"
              icon={<SwipeUp color="disabled" fontSize="small" />}
              name="DateVal"
              type="date"
            />
            <InputForm
              disabled
              width={7}
              label="Date Livraison prévue"
              icon={<SwipeUp color="disabled" fontSize="small" />}
              name="DateLivraison"
              type="date"
            />
          </Grid>

          {/* Colonne droite : détails financiers et paiement */}
          <Grid item xs={12} md={6} lg={6} className="border-left">
            <legend>Détails du financement</legend>
            <InputForm
              disabled
              money
              width={7}
              label="Montant total"
              icon={<MonetizationOnOutlined fontSize="small" />}
              name="MontantFinancement"
              type="text"
            />
            <InputForm
              disabled
              money
              width={7}
              label="Montant validé"
              icon={<MonetizationOnOutlined fontSize="small" />}
              name="MontantValide"
              type="text"
            />
            <InputForm
              disabled
              money
              width={7}
              label="Total payé"
              icon={<MonetizationOnOutlined fontSize="small" />}
              name="TotalPaye"
              type="text"
            />
            <InputForm
              disabled
              money
              width={7}
              label="Reste à payer"
              icon={<MonetizationOnOutlined fontSize="small" />}
              name="ResteAPayer"
              type="text"
            />
            <InputForm
              disabled={false}
              money
              width={7}
              label="Montant à payer"
              icon={<MonetizationOnOutlined fontSize="small" />}
              name="MontantADecaisser"
              type="number"
              dependencies={['ResteAPayer']}
              rules={[
                ({ getFieldValue }: any) => ({
                  validator(_: any, value: any) {
                    const reste = getFieldValue('ResteAPayer') || 0;
                    if (!value || value <= reste) return Promise.resolve();
                    return Promise.reject(
                      new Error(`Le montant à payer ne peut pas dépasser le reste à payer (${reste})`)
                    );
                  },
                }),
              ]}
            />
            <InputForm
              row={2}
              disabled={false}
              width={7}
              label="Raison du paiement"
              icon={<MonetizationOnOutlined fontSize="small" />}
              name="RaisonDecaisse"
              type="TextArea"
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Tab1;